// Expansion modules canon. Prices LOCKED.
// Asset Protection is split into TWO SKUs per canon (Standard $49 / Premium $99).
import { MODULE_SKUS } from "@/lib/sku";

export const MODULES = [
    {
        id: "smithers-guidance",
        name: "Smithers Guidance Layer",
        price: "$79/mo",
        desc: "AI-guided decisions. Live execution support.",
        icon: "brain",
        sku: MODULE_SKUS.smithers_guidance,
    },
    {
        id: "quadra-core",
        name: "QUADRA Core® Activation",
        price: "$49/mo",
        desc: "Disciplined reasoning. Enhanced processing.",
        icon: "chip",
        sku: MODULE_SKUS.quadra_activation,
    },
    {
        id: "creator-network",
        name: "Creator Network Integration",
        price: "$29/mo",
        desc: "Connect & collaborate across the ecosystem.",
        icon: "network",
        sku: MODULE_SKUS.creator_network,
    },
    {
        id: "asset-workspace",
        name: "Asset Workspace",
        price: "$19/mo",
        desc: "Organize your builds. Storage + editing tools.",
        icon: "folder",
        sku: MODULE_SKUS.asset_workspace,
    },
    {
        id: "asset-protection",
        name: "Asset Protection",
        price: "$49–99/mo",
        desc: "Secure your IP. Monitoring + .VIG wrapping.",
        icon: "shield",
        // Asset Protection has two SKUs — handled in ModuleCard via `variants`.
        sku: MODULE_SKUS.asset_protection_base,
        variants: [
            { id: "base",    label: "Standard", price: "$49/mo", sku: MODULE_SKUS.asset_protection_base },
            { id: "premium", label: "Premium",  price: "$99/mo", sku: MODULE_SKUS.asset_protection_premium },
        ],
    },
    {
        id: "deployment-engine",
        name: "Deployment Engine",
        price: "$99/mo",
        desc: "Launch at scale. Operationalization infrastructure.",
        icon: "rocket",
        sku: MODULE_SKUS.deployment_engine,
    },
];
